import { useEffect, useState } from 'react';
import Raven from 'raven-js';
import { fetchAvailableSeats } from 'purchase-motions-api/query/seats';
import { fetchProductInventory } from 'purchase-motions-api/query/monetization';
import { getOwnedProductsThatRequireCoreSeat, getSeatSelectOptions } from '../utils/seats';
const INITIAL_STATE = {
  availableSeatOptions: [],
  defaultSeat: null
};
export const useAvailableSeats = () => {
  const [data, setData] = useState(INITIAL_STATE);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [seats, products] = await Promise.all([fetchAvailableSeats(), fetchProductInventory()]);
        const ownedProductsThatRequireCoreSeat = getOwnedProductsThatRequireCoreSeat(products);
        const availableSeatOptions = getSeatSelectOptions(seats, ownedProductsThatRequireCoreSeat);
        const defaultSeat = availableSeatOptions.length > 0 ? availableSeatOptions[0].value : null;
        setData({
          availableSeatOptions,
          defaultSeat
        });
      } catch (e) {
        const errorObj = e instanceof Error ? e : new Error(String(e));
        Raven.captureException(errorObj, {
          fingerprint: ['Error fetching available seats data']
        });
        setError(errorObj);
      } finally {
        setLoading(false);
      }
    };
    void fetchData();
  }, []);
  return {
    data,
    error,
    loading
  };
};